import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Controller, useFormContext, useWatch } from "react-hook-form";

import { CAPGUARD_PORT_TYPES } from "../OrderForm.options";
import { OrderFormData } from "../OrderForm.schema";

dayjs.extend(customParseFormat);

export function DepositSection() {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<OrderFormData>();

  const portType = useWatch({ name: "dpPortType" });
  const isCapguard = CAPGUARD_PORT_TYPES.includes(portType ?? "");

  return (
    <div className="space-y-3">
      {/* One-off Deposit */}
      <div className="grid grid-cols-[180px_1fr] items-center gap-3">
        <label className="text-sm font-medium text-right text-gray-600 dark:text-gray-400">
          One-off Deposit:
        </label>
        <input
          type="number"
          min={0}
          step={1000}
          disabled={!isCapguard}
          {...register("dpOnOffAmount", { valueAsNumber: true })}
          className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-400"
        />
      </div>

      {/* One-off date */}
      <div className="grid grid-cols-[180px_1fr] items-center gap-3">
        <label className="text-sm font-medium text-right text-gray-600 dark:text-gray-400">
          One-off date:
        </label>
        <div className="flex flex-col gap-1">
          <Controller
            control={control}
            name="dpOnOffDate"
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={field.value ? dayjs(field.value) : null}
                  onChange={(d) =>
                    field.onChange(d?.isValid() ? d.format("DD.MM.YYYY") : "")
                  }
                  format="DD.MM.YYYY"
                  disabled={!isCapguard}
                  slotProps={{
                    inputAdornment: { position: "start" },
                    textField: {
                      size: "small",
                      error: !!errors.dpOnOffDate,
                      sx: {
                        width: 160,
                        "& .MuiOutlinedInput-root": {
                          fontSize: "0.875rem",
                          borderRadius: "0.375rem",
                          backgroundColor: "white",
                          "& fieldset": { borderColor: "#d1d5db" },
                          "&:hover fieldset": { borderColor: "#9ca3af" },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                            borderWidth: 2,
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f9fafb",
                            "& fieldset": { borderColor: "#d1d5db" },
                          },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
          {errors.dpOnOffDate && (
            <p className="text-xs text-red-500">{errors.dpOnOffDate.message}</p>
          )}
        </div>
      </div>
    </div>
  );
}
